export const TITLE = "AWS Partner Funding Tool";
